import { useQuery } from '@tanstack/react-query';
import { Card, CardEyebrow, CardTitle, CardContent, TicketCard } from '@bookrcs/ui';
import { api } from '../lib/api.js';
import { useAuth } from '../lib/auth.js';
import type { Message } from '@bookrcs/types';

export default function MessagesRoute() {
  const { session } = useAuth();
  const {
    data: messages,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ['messages', session?.proId, 'recent'],
    queryFn: () =>
      api<Message[]>('/messages', {
        searchParams: { proId: session?.proId ?? '', limit: 50 },
      }),
    enabled: Boolean(session?.proId),
  });

  return (
    <div className="grid gap-6 max-w-4xl">
      <header>
        <p className="text-[var(--text-muted)] m-0">Messages</p>
        <h1 className="font-serif text-4xl md:text-5xl font-extrabold m-0 mt-1 text-[var(--text)]">
          Conversations
        </h1>
      </header>

      <Card>
        <CardEyebrow>Triage</CardEyebrow>
        <CardTitle>Messages récents</CardTitle>
        <CardContent>
          {isLoading ? <p className="text-[var(--text-muted)]">Chargement…</p> : null}
          {isError ? (
            <p className="text-[var(--urgent)]">
              L'API ne répond pas. Vérifie `@bookrcs/api` (port 4000).
            </p>
          ) : null}
          {messages && messages.length === 0 ? (
            <p className="text-[var(--text-muted)] italic">
              Pas encore de message. L'assistant prendra le premier dès qu'un client écrira.
            </p>
          ) : null}
          {messages && messages.length > 0 ? (
            <ul className="grid gap-2 mt-2 list-none p-0">
              {messages.slice(0, 10).map((m) => (
                <li key={m.id}>
                  <TicketCard
                    urgent={m.intent === 'COMPLAINT' || m.sentiment === 'EN_COLERE'}
                    ticket={{
                      id: m.id.slice(0, 6),
                      time: new Date(m.createdAt).toLocaleTimeString('fr-FR', {
                        hour: '2-digit',
                        minute: '2-digit',
                      }),
                      title: `${m.direction === 'inbound' ? 'IN' : 'OUT'} · ${m.channel.toUpperCase()}`,
                      detail: m.body ?? '(carte RCS)',
                      meta: m.intent ? `intent: ${m.intent}` : undefined,
                    }}
                  />
                </li>
              ))}
            </ul>
          ) : null}
        </CardContent>
      </Card>
    </div>
  );
}
